
define('modules/application/wizard/classes/engines',[
    "app",

    // Libs
    "backbone",

    // Classes
    "./genericCollectionSection"

  ],

  function(app, Backbone, genericCollectionSection) {
    var eventsToBind = _.extend({}, genericCollectionSection.genericCollectionItem.View.prototype.events);
    var genericCollectionItem = _.extend({}, genericCollectionSection.genericCollectionItem, {
      View: genericCollectionSection.genericCollectionItem.View.extend({
        tagName: "li",
        className: "engines",
        template: "application/wizard/sections/genericCollectionSection/enginesItem",
        events: _.extend(eventsToBind, {
          "click"                           : "itemClickedEventHandler",
          "change .group"                   : "groupChangedEventHandler",
          "change .masterType"              : "typeChangedEventHandler",
          "change .slaveType"               : "slaveTypeChangedEventHandler",
          "click .checkbox"                 : "isSlaveChangedEventHandler",
          "keyup  input[name='description']": "descriptionChangedEventHandler",
          "click .global .ui-spinner-down"  : "decrementButtonClickedEventHandler",
          "click .global .ui-spinner-up"    : "incrementButtonClickedEventHandler",
          "click .slave .ui-spinner-down"   : "decrementSlaveButtonClickedEventHandler",
          "click .slave .ui-spinner-up"     : "incrementSlaveButtonClickedEventHandler",
          "click .radio"                    : "typeOfEngineChangedEventHandler"
        }),

        serialize: function() {
          return {
            model: this.model,
            app: app
          };
        },

        initialize: function() {
          this.model.bind("render:requested", this.render, this);
          this.model.bind("updateViews", this.render, this);
          this.model.bind("change:value", this.render, this);
          //this.model.bind("change:number", this.render, this);
        },

        itemClickedEventHandler: function() {
          this.model.set("selected", true);
        },

        groupChangedEventHandler: function(e) {
          var groupId = e.currentTarget.value;

          //Update the model
          this.model.setGroup(groupId);
        },

        typeOfEngineChangedEventHandler: function(e) {
          var typeOfEngine = this.$el.find("[name='typeOfEngine-" + this.model.get("number") + "']:checked").val();
          this.model.set("typeOfEngine", typeOfEngine);
        },

        typeChangedEventHandler: function(e) {
          var typePackageClassId = e.currentTarget.value;

          //Update the model
          this.model.setPackage(typePackageClassId);
        },

        slaveTypeChangedEventHandler: function(e) {
          var slavePackageClassId = e.currentTarget.value;

          //Update the model
          this.model.setPackage(slavePackageClassId);
        },

        descriptionChangedEventHandler: function(e) {
          this.model.set("description", e.currentTarget.value);
        },

        isSlaveChangedEventHandler: function() {
          var checkedBox = this.$el.find("[.isSlave:checked");

          return this.model.setIsSlave(checkedBox.length > 0);
        },

        incrementButtonClickedEventHandler: function(e) {
          e.preventDefault();
          e.stopPropagation();
          this.model.incrementValue();
          return false;
        },

        decrementButtonClickedEventHandler: function(e) {
          e.preventDefault();
          e.stopPropagation();
          this.model.decrementValue();
          return false;
        },

        incrementSlaveButtonClickedEventHandler: function(e) {
          e.preventDefault();
          e.stopPropagation();
          this.model.incrementSlaveValue();
          return false;
        },

        decrementSlaveButtonClickedEventHandler: function(e) {
          e.preventDefault();
          e.stopPropagation();
          this.model.decrementSlaveValue();
          return false;
        },

        afterRender: function() {
          this.$el.find("select").removeAttr("rel");
          window.customizeFormElements.call();

        }

      }),
      Model: genericCollectionSection.genericCollectionItem.Model.extend({
        defaults: {
          number: -1,
          filterId: -1,
          selected: false,
          description: "",
          value: 1,
          isSlave: false,
          typeOfEngine: "rollingShutters",
          slaveValue: 1
        },

        initialize: function() {
          var groups = this.getGroups(),
            wizardChoiceCode = this.get("wizardChoiceCode"),
            choosenGroup = this.get("choosenGroup"),
            packageClassId = this.get("packageClassId"),
            that = this,
            choosenPackage;

          this.unbind("change:packageClassId", this.addPackageDetails);
          this.bind("change:packageClassId", this.addPackageDetails, this);

          this.bind("product:fetched", this.renderPackage, this);
          this.bind("accessory:fetched", this.renderAccessory, this);

          this.bind("change:selected", this.selectedStatusChangedEventHandler, this);
          this.bind("change:typeOfEngine", this.typeOfEngineChanged, this);
          this.bind("change:choosenGroup", this.choosenGroupChanged, this);

          if (!choosenGroup) {
            if (!packageClassId) {
              this.set("choosenGroup", groups[0].code);
              choosenGroup = this.get("choosenGroup");
            } else {
              choosenGroup = _.filter(groups, function(iterableGroup) {
                var isTheRightGroup = false;
                for (var i = 0, length = iterableGroup.packages.length; i < length; i++) {
                  if (iterableGroup.packages[i].packageClassId === packageClassId) {
                    isTheRightGroup = true;
                    break;
                  }
                }
                return isTheRightGroup;
              });
              this.set("choosenGroup", choosenGroup[0].code);
              choosenGroup = choosenGroup[0].code;
            }
          }

          choosenGroup = _.filter(groups, function(iterableGroup) {
            return iterableGroup.code === choosenGroup;
          })[0];

          //Master Package
          if (!this.get("isSlave")) {
            if (!this.get("masterPackage"))
              this.setPackage(choosenGroup.packages[0].packageClassId);
            else {
              if (!this.get("masterPackage").packageClassId)
                choosenPackage = _.filter(choosenGroup.packages, function(iterablePackage) {
                  return (iterablePackage.packageClassId === that.get("masterPackage"));
                })[0];
              else
                choosenPackage = _.filter(choosenGroup.packages, function(iterablePackage) {
                  return (iterablePackage.packageClassId === that.get("masterPackage").packageClassId);
                })[0];

              if (choosenPackage)
                this.setPackage(choosenPackage.packageClassId);
            }
          }

          //Slave Package
          if (this.get("isSlave")) {
            if (!this.get("slavePackage") && this.get("isSlave"))
              this.setPackage(choosenGroup.packages[0].packageClassId);
            else {
              if (!this.get("slavePackage").packageClassId)
                choosenPackage = _.filter(choosenGroup.packages, function(iterablePackage) {
                  return (iterablePackage.packageClassId === that.get("slavePackage"));
                })[0];
              else
                choosenPackage = _.filter(choosenGroup.packages, function(iterablePackage) {
                  return (iterablePackage.packageClassId === that.get("slavePackage").packageClassId);
                })[0];

              if (choosenPackage)
                this.setPackage(choosenPackage.packageClassId);
            }
          }
        },

        getOccupiedAddresses: function() {
          var occupation = this.get("typeOfEngine") === "rollingShutters" ? 2 : 4,
            valueToReturn = !this.get("isSlave") ? this.get("masterPackage").specialVars.slot * this.get("value") / occupation : 0;
          return valueToReturn;
        },

        renderPackage: function(packageToRender) {
          if (packageToRender)
            this.attributes.masterPackage = packageToRender;

          this.trigger("render:requested");
        },

        renderAccessory: function(packageToRender) {
          if (packageToRender) {
            if (this.attributes.slavePackage) {
              _.extend(this.attributes.slavePackage, packageToRender);
            } else {
              this.attributes.slavePackage = packageToRender;
            }
          }

          this.trigger("render:requested");
        },

        addPackageDetails: function(packageClassId, _isSlave) {
          this.packageClassIdChangedEventHandler();
          var isSlave = this.get("isSlave");

          if (_isSlave)
            isSlave = _isSlave;

          var currentGroupId = this.get("choosenGroup"),
            groups = this.getGroups(isSlave),
            selectedGroup = _.filter(groups, function(iterableGroup) {
              return (iterableGroup.code === currentGroupId);
            })[0],
            packageToSet;

          if (packageClassId) {
            selectedGroup = _.filter(groups, function(iterableGroup) {
              return _.filter(iterableGroup.packages, function(iterablePackage) {
                return iterablePackage.packageClassId === packageClassId;
              }).length > 0;
            })[0];

            if (!selectedGroup) {
              selectedGroup = _.filter(groups, function(iterableGroup) {
                return (iterableGroup.code === currentGroupId);
              })[0];
              packageClassId = selectedGroup.packages[0].packageClassId;
            }

            this.set("choosenGroup", selectedGroup.code);
          }

          if (!packageClassId) {
            if (isSlave)
              packageToSet = _.filter(selectedGroup.packages, function(iterablePackage) {
                return (!iterablePackage.specialVars.isMaster);
              })[0];
            else
              packageToSet = _.filter(selectedGroup.packages, function(iterablePackage) {
                return (iterablePackage.specialVars.isMaster);
              })[0];
          } else
            packageToSet = _.filter(selectedGroup.packages, function(iterablePackage) {
              return (iterablePackage.packageClassId === packageClassId);
            })[0];

          this.fetchProduct(packageToSet, isSlave);
        },

        packageClassIdChangedEventHandler: function() {
          this.get("collectionEventAggregator").trigger("updateGlobalLengths");
        },

        typeOfEngineChanged: function() {
          var groups = this.getGroups();
          if (groups.length === 0) {
            this.set("isSlave", false);
            groups = this.getGroups();
          }
          this.setGroup(groups[0].code);
          this.trigger("render:requested");
        },

        choosenGroupChanged: function() {
          var groups = this.getGroups(),
            isMaster = this.get("isSlave") ? !this.get("isSlave") : true,
            typeOfLight = this.get("typeOfLight"),
            isDim = typeOfLight === "dimmer",
            choosenGroup = this.get("choosenGroup"),
            choosenGroupPackages = _.filter(groups, function(iterableGroup) {
              return iterableGroup.code === choosenGroup;
            })[0].packages,
            masterPackages = _.filter(choosenGroupPackages, function(iterablePackage) {
              return iterablePackage.specialVars.isMaster === isMaster && iterablePackage.specialVars.isDim === isDim;
            });

          if (this.get('packageClassId')){
            this.setPackage(this.get('packageClassId'));
          } else {
            this.setPackage(masterPackages[0].packageClassId);
          }
        },

        fetchProduct: function(packageToValorize, _isSlave) {
          var that = this,
            isSlave = false,
            fetchedAccessories = this.get("fetchedAccessories");

          if (_isSlave)
            isSlave = _isSlave;

          if (!packageToValorize.isPopulated) {
            if (!isSlave)
              this.trigger("product:fetching");

            BticinoS4B.Instances.Models.ApplicationModel.getProducts(packageToValorize.packageClassId, function(data) {
              var mainProduct = _.filter(data.products, function(product) {
                return (product.mnemonic === 1);
              })[0];
              var secondaryProducts = _.filter(data.products, function(product) {
                return (product.mnemonic !== 1);
              });

              _.extend(packageToValorize, mainProduct);
              packageToValorize.secondaryProducts = secondaryProducts;
              packageToValorize.isPopulated = true;

              if (!isSlave)
                that.trigger("product:fetched", packageToValorize);
              else
                that.trigger("accessory:fetched", packageToValorize);

            });
          } else {
            if (!isSlave)
              this.trigger("product:fetched", packageToValorize);
            else
              that.trigger("accessory:fetched", packageToValorize);
          }
        },

        getGroups: function(newSlaveStatus) {
          var groups = this.get("groups"),
            systemChoices = BticinoS4B.Instances.Models.ApplicationModel.get("choosenSystems"),
            rollingShuttersEnabled = _.contains(systemChoices, "lightsAndRollingShutters"),
            typeOfEngine = this.get("typeOfEngine"),
            isMaster = newSlaveStatus !== undefined ? !newSlaveStatus : (this.get("isSlave") ? !this.get("isSlave") : true),
            compatibilityArray = [],
            filteredGroups = [],
            filteredPackages = [],
            groupToAssign = {};

          if (typeOfEngine === "rollingShutters")
            compatibilityArray.push("t");
          else
            compatibilityArray.push("p");

          var checkCompatibility = function(iterablePackage) {
            if (iterablePackage.specialVars.compatibilities)
              for (var j = 0; j < compatibilityArray.length; j++)
                return (_.contains(iterablePackage.specialVars.compatibilities, compatibilityArray[j]) &&
                  iterablePackage.specialVars.isDim === false &&
                  iterablePackage.specialVars.isMaster === isMaster
                );
          };

          for (var i = 0; i < groups.length; i++) {
            filteredPackages = _.filter(groups[i].packages, checkCompatibility);

            if (filteredPackages.length > 0) {
              groupToAssign = _.extend({}, groups[i]);
              groupToAssign.packages = filteredPackages;
              filteredGroups.push(groupToAssign);
            }
          }
          return filteredGroups;
        },

        setIsSlave: function(newSlaveStatus) {
          var choosenGroup = this.getGroups(newSlaveStatus)[0],
            packageClassId = _.filter(choosenGroup.packages, function(iterablePackage) {
              return iterablePackage.specialVars.isMaster !== newSlaveStatus;
            })[0].packageClassId;

          var loadOccupation = this.get("typeOfEngine") === "rollingShutters" ? 2 : 4;

          this.get("collectionEventAggregator").bind("element:changeApproved", this.completeChange, this);
          this.get("collectionEventAggregator").bind("element:changeNotApproved", this.abortChange, this);
          this.set("changeInProgress", true);
          this.get("collectionEventAggregator").trigger("element:changeRequested", {
            number: this.get("number"),
            packageClassId: packageClassId,
            group: this.get("choosenGroup"),
            newLoadOccupation: loadOccupation,
            newSlaveStatus: newSlaveStatus
          });
        },

        selectedStatusChangedEventHandler: function() {
          if (this.get("selected"))
            this.get("collectionEventAggregator").trigger("selectedItem:changed", this);
          this.trigger("render:requested");
        },

        setGroup: function(groupId) {
          var groups = this.getGroups(),
            that = this,
            selectedGroup = _.filter(groups, function(iterableGroup) {
              return (iterableGroup.code === groupId);
            })[0],
            packageToAssign = _.filter(selectedGroup.packages, function(iterablePackage) {
              if (that.get("isSlave"))
                return !iterablePackage.specialVars.isMaster;
              else
                return iterablePackage.specialVars.isMaster;
            });
          this.set("choosenGroup", groupId);

          var loadOccupation = this.get("typeOfEngine") === "rollingShutters" ? 2 : 4;

          if (!this.get("isSlave")) {
            if (packageToAssign.length > 0)
              this.setPackage(packageToAssign[0].packageClassId, loadOccupation);
          } else {
            if (packageToAssign.length > 0)
              this.setPackage(packageToAssign[0].packageClassId, loadOccupation);
          }
        },

        setPackage: function(packageClassId, newLoadOccupation) {

          var loadOccupation = newLoadOccupation ? newLoadOccupation : (this.get("typeOfEngine") === "rollingShutters" ? 2 : 4);

          this.get("collectionEventAggregator").bind("element:changeApproved", this.completeChange, this);
          this.get("collectionEventAggregator").bind("element:changeNotApproved", this.abortChange, this);
          this.set("changeInProgress", true);
          this.get("collectionEventAggregator").trigger("element:changeRequested", {
            number: this.get("number"),
            packageClassId: packageClassId,
            group: this.get("choosenGroup"),
            newLoadOccupation: loadOccupation,
            newSlaveStatus: this.get("isSlave")
          });
        },

        completeChange: function(params) {
          var packageClassId = params.packageClassId,
            newSlaveStatus = params.newSlaveStatus,
            groupId = params.choosenGroup,
            isSlave = newSlaveStatus !== undefined ? newSlaveStatus : this.get("isSlave");

          this.set("incrementInProgress", false);
          this.get("collectionEventAggregator").unbind("element:changeApproved");
          this.get("collectionEventAggregator").unbind("element:changeNotApproved");

          var groups = this.getGroups(newSlaveStatus),
            selectedGroup = _.filter(groups, function(iterableGroup) {
              return _.filter(iterableGroup.packages, function(iterablePackage) {
                return iterablePackage.packageClassId === packageClassId;
              }).length > 0;
            })[0];

          if (!selectedGroup) {
            groupId = groups[0].code;
            selectedGroup = groups[0];
          }

          var packageToAssign = _.filter(selectedGroup.packages, function(iterablePackage) {
            return iterablePackage.packageClassId === packageClassId;
          })[0];

          if (!packageToAssign)
            packageToAssign = _.filter(selectedGroup.packages, function(iterablePackage) {
              return iterablePackage.specialVars !== isSlave;
            })[0];

          if (groupId)
            this.attributes.choosenGroup = groupId;

          if (isSlave)
            this.attributes.slavePackage = packageToAssign;
          else
            this.attributes.masterPackage = packageToAssign;

          this.attributes.isSlave = isSlave;

          this.addPackageDetails(packageClassId, newSlaveStatus);
          this.trigger("render:requested");
          this.get("collectionEventAggregator").trigger("updateViews");
        },

        abortChange: function() {
          this.set("incrementInProgress", false);
          this.get("collectionEventAggregator").unbind("element:changeApproved");
          this.get("collectionEventAggregator").unbind("element:changeNotApproved");
          alert("It's not possible to proceed with this change. Please review your choices");
          this.trigger("render:requested");
        },

        incrementValue: function() {
          var loadOccupation = this.get("typeOfEngine") === "rollingShutters" ? 2 : 4;
          var params = {
            actuatorSlots: this.get("masterPackage").specialVars.slot,
            loadOccupation: loadOccupation
          };

          this.get("collectionEventAggregator").bind("element:incrementApproved", this.completeIncrement, this);
          this.get("collectionEventAggregator").bind("element:incrementNotApproved", this.abortIncrement, this);
          this.set("incrementInProgress", true);
          this.get("collectionEventAggregator").trigger("element:incrementRequested", params);
        },

        completeIncrement: function() {
          if (this.get("incrementInProgress")) {

            this.set("incrementInProgress", false);
            this.set("value", (this.get("value") + 1));

            this.get("collectionEventAggregator").trigger("updateGlobalLengths");
            this.get("collectionEventAggregator").trigger("updateViews");
          }

          this.get("collectionEventAggregator").unbind("element:incrementApproved");
          this.get("collectionEventAggregator").unbind("element:incrementNotApproved");
        },

        abortIncrement: function() {
          this.set("incrementInProgress", false);
          this.get("collectionEventAggregator").unbind("element:incrementApproved");
          this.get("collectionEventAggregator").unbind("element:incrementNotApproved");
        },

        decrementValue: function() {
          var value = this.get("value");

          if ((value - 1) >= 1) {
            this.set("value", (value - 1));
            this.get("collectionEventAggregator").trigger("updateGlobalLengths");
            this.get("collectionEventAggregator").trigger("updateViews");
            this.trigger("render:requested");
          }
        },

        incrementSlaveValue: function() {
          this.set("slaveValue", (this.get("slaveValue") + 1));
          this.trigger("render:requested");
        },

        decrementSlaveValue: function() {
          var slaveValue = this.get("slaveValue");

          if ((slaveValue - 1) >= 1) {
            this.set("slaveValue", (slaveValue - 1));
            this.trigger("render:requested");
          }
        },

        enableChangeMode: function() {
          this.set("changeMode", true);
          this.get("collectionEventAggregator").bind("abilitationToChangeExpansionType:granted", this.completeTypeChange, this);
          this.get("collectionEventAggregator").bind("abilitationToChangeExpansionType:refused", this.revertTypeChange, this);
        },

        disableChangeMode: function() {
          this.set("changeMode", false);
          this.get("collectionEventAggregator").unbind("abilitationToChangeExpansionType:granted", this.completeTypeChange);
          this.get("collectionEventAggregator").unbind("abilitationToChangeExpansionType:refused", this.revertTypeChange);
        },

        completeTypeChange: function(packageAttributes) {
          this.set(packageAttributes);
          this.set("futureBonusVde", undefined);
          this.disableChangeMode();
          window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
          this.trigger("render:requested");
        },

        revertTypeChange: function(packageAttributes) {
          this.set("futureBonusVde", undefined);
          this.disableChangeMode();
          alert("Unable to continue");
          this.trigger("render:requested");
        },

        resetValues: function() {
          this.set("catalogId", undefined);
          this.set("description", undefined);
          this.set("image", undefined);
          this.set("links", undefined);
          this.set("mnemonic", undefined);
          this.set("optionalPackages", undefined);
          this.set("packageActuator", undefined);
          this.set("packageClassId", undefined);
          this.set("packageClassLabel", undefined);
          this.set("packageInDepth", undefined);
          this.set("packageLoad", undefined);
          this.set("price", undefined);
          this.set("productCode", undefined);
          this.set("productDescription", undefined);
          this.set("productInDepth", undefined);
          this.set("productLabel", undefined);
          this.set("specialVars", undefined);
          this.set("wizardChoiceDescription", undefined);
          this.set("wizardChoiceLabel", undefined);
          this.set("packageClassDescription", undefined);
          this.set("packageClassId", undefined);
          this.set("packageClassLabel", undefined);
        },

        deliverCurrent: function() {
          var mainProductSpecialVars,
            accessorySpecialVars;

          var sendConsumption = function(consumption) {
            if (consumption) {
              var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");

              if (consumption < 0)
                consumptionIndicatorModel.addSupplyCurrent(consumption);
              else
                consumptionIndicatorModel.addCurrentConsumption(consumption);
            }
          };

          var packageToAnalyze = this.get("isSlave") ? this.get("slavePackage") : this.get("masterPackage");

          if (packageToAnalyze.specialVars) {
            if (!(packageToAnalyze.specialVars instanceof Object))
              packageToAnalyze.attributes.specialVars = JSON.parse(packageToAnalyze.attributes.specialVars);

            if ((packageToAnalyze.specialVars.consumptionGroupId) && (packageToAnalyze.specialVars.groupExtraConsumption)) {
              var consumptionGroupId = packageToAnalyze.specialVars.consumptionGroupId.toString();
              var groupExtraConsumption = packageToAnalyze.specialVars.groupExtraConsumption;
              var maxExtraConsumptions = BticinoS4B.Instances.Models.ApplicationModel.get("maxExtraConsumption");

              if ((!maxExtraConsumptions[consumptionGroupId]) || (maxExtraConsumptions[consumptionGroupId] < groupExtraConsumption))
                maxExtraConsumptions[consumptionGroupId] = groupExtraConsumption;

              BticinoS4B.Instances.Models.ApplicationModel.set("maxExtraConsumption", maxExtraConsumptions);
            }

            if (packageToAnalyze.specialVars.currentConsumption)
              sendConsumption(packageToAnalyze.specialVars.currentConsumption * this.get("value"));
          }

          if (packageToAnalyze.accessory && packageToAnalyze.accessory.specialVars) {
            if (!(packageToAnalyze.accessory.specialVars instanceof Object))
              packageToAnalyze.attributes.accessory.specialVars = JSON.parse(packageToAnalyze.attributes.accessory.specialVars);

            if (packageToAnalyze.accessory.specialVars.currentConsumption)
              sendConsumption(packageToAnalyze.accessory.specialVars.currentConsumption * this.get("value"));
          }
        }
      })
    });

    var collectionItemModel = genericCollectionItem.Model;
    var collectionModel = Backbone.Collection.extend({
      model: collectionItemModel
    });

    var engines = _.extend({}, genericCollectionSection, {

      Views: {
        titleBar: genericCollectionSection.Views.titleBar.extend({
          setLabel: function() {

            var actuatorString = "IDS_W4_9013",
              addressString = "IDS_W4_9015";

            if (this.model.get("value") === 1)
              actuatorString = "IDS_W4_9013_sing";

            var collection = this.model.get("collection"),
              i, length = collection.models ? collection.models.length : 0,
              addresses = 0,
              actuators = 0,
              quote = "";

            for (i = 0; i < length; i++) {
              addresses += collection.models[i].getOccupiedAddresses();
              actuators += collection.models[i].get("value");
            }

            if (actuators === 1)
              actuatorString = "IDS_W4_9013_sing";

            if (addresses === 1)
              addressString = "IDS_W4_9015_sing";

            if (addresses > 0 || actuators > 0)
              quote = addresses + " " + $.i18n._(addressString) + " - " + actuators + " " + $.i18n._(actuatorString);

            genericCollectionSection.Views.titleBar.prototype.setLabel.apply(this, [quote]);
          },

          afterRender: function() {
            this.setLabel();
          }
        }),
        content: genericCollectionSection.Views.content.extend({
          template: "application/wizard/sections/genericCollectionSection/collectionWithInfo",
          events: _.extend(_.extend({}, genericCollectionSection.Views.content.prototype.events), {
            "click .toggleInfoButton": "toggleInfos"
          }),

          initialize: function() {
            genericCollectionSection.Views.content.prototype.initialize.apply(this);

            //Binding events
            window.BticinoS4B.eventAggregator.unbind("accessoryLine:chosen", this.accessoryLineChosenEventHandler);
            window.BticinoS4B.eventAggregator.bind("accessoryLine:chosen", this.accessoryLineChosenEventHandler, this);

            this.model.unbind("packages:fetched", this.packagesFetchedEventHandler);
            this.model.bind("packages:fetched", this.packagesFetchedEventHandler, this);

            this.model.bind("item:added", this.insertItemView, this);
          },

          toggleInfos: function(e) {
            return genericCollectionSection.Views.content.prototype.toggleInfos(e, this);
          },

          packagesFetchedEventHandler: function() {
            this.$el.find(".loadingSection").hide();
            this.$el.find(".regularSection").show();
            this.render();
          },

          showLoader: function() {
            this.$el.find(".regularSection").hide();
            this.$el.find(".loadingSection").show();
          },

          //Event handlers
          accessoryLineChosenEventHandler: function(accessoryLineId) {
            this.showLoader();
            this.model.fetchPackages();
          },

          addItemButtonClickedEventHandler: function() {
            var collectionItemView = genericCollectionItem.View;
            var elementToAdd = this.model.addItem();
            if (elementToAdd) {
              var viewToAdd = new collectionItemView({
                model: elementToAdd
              });
              //this.insertView(".elements", viewToAdd);
              this.model.sortItems();
              this.$el.find(".alert").remove();
              viewToAdd.render();
            }
          },

          duplicateItemButtonClickedEventHandler: function() {
            var collectionItemView = genericCollectionItem.View;
            var elementToAdd = this.model.duplicateSelectedItem();
            if (elementToAdd) {
              var viewToAdd = new collectionItemView({
                model: elementToAdd
              });
              //this.insertView(".elements", viewToAdd);
              this.model.sortItems();
              this.$el.find(".alert").remove();
              viewToAdd.render();
            }
          },

          removeItemButtonClickedEventHandler: function() {
            var elementToRemove = this.model.removeSelectedItem();
            var viewToRemove = this.getView(function(view) {
              return (elementToRemove === view.model);
            });
            if (viewToRemove) {
              viewToRemove.$el.remove();
              this.model.sortItems();
            }
          },

          insertItemView: function(model) {
            var collectionItemView = genericCollectionItem.View;
            this.insertView(".elements", new collectionItemView({
              model: model
            }));
          },

          beforeRender: function() {
            var collection = this.model.get("collection"),
              collectionLength = collection.length,
              i = 0;

            if (collection.models) {
              for (i = 0; i < collectionLength; i++)
                this.insertItemView(collection.models[i]);
            }
          },

          afterRender: function() {
            var accessoryLineId = BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId"),
              systems = BticinoS4B.Instances.Models.ApplicationModel.get("choosenSystems"),
              systemsLength = systems.length,
              consumptionVisualizationEnabled = false,
              i = 0;

            for (i = 0; i < systemsLength; i++)
              if (systems[i] === "lightsAndRollingShutters") {
                consumptionVisualizationEnabled = true;
                break;
              }

            if (!consumptionVisualizationEnabled)
              this.$el.html("<h4 class='alert'>" + $.i18n._("IDS_W1_9102") + "</h4>");
            else {
              if (accessoryLineId && (!this.model.get("packagesFetched"))) {
                this.showLoader();
                this.model.fetchPackages();
              }
              window.customizeFormElements.call();
            }
          }

        })
      },

      Model: genericCollectionSection.Model.extend({
        defaults: _.extend({
          name: "IDS_WAM8_31",
          collectionEventAggregator: _.extend({}, Backbone.Events),
          infoQuote: "IDS_WGENTT_000042"
        }, genericCollectionSection.Model.prototype.defaults),

        initialize: function() {
          genericCollectionSection.Model.prototype.initialize.apply(this);
          var that = this;
          var collection;
          var oldCollection, i = 0,
            collectionEventAggregator = this.get("collectionEventAggregator");

          window.BticinoS4B.eventAggregator.bind("load:Project", this.loadProject, this);

          if (BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId") && BticinoS4B.Instances.Models.ApplicationModel.get("accessoryLineId") !== "0")
            this.fetchPackages();
          else
            window.BticinoS4B.eventAggregator.bind("accessoryLineId:chosen", this.fetchPackages, this);

          this.set("maxItem", 81);

          collectionEventAggregator.unbind("selectedItem:changed", this.selectedItemChangedEventHandler);
          collectionEventAggregator.bind("selectedItem:changed", this.selectedItemChangedEventHandler, this);

          collectionEventAggregator.bind("element:incrementRequested", function(params) {
            var actuatorSlots = params.actuatorSlots,
              loadOccupation = params.loadOccupation;

            if (this.isPossibleToAdd(actuatorSlots, loadOccupation))
              collectionEventAggregator.trigger("element:incrementApproved");
            else
              collectionEventAggregator.trigger("element:incrementNotApproved");
          }, this);

          collectionEventAggregator.bind("element:changeRequested", function(params) {
            var groups = this.get("groups"),
              groupId = params.group,
              packageClassId = params.packageClassId,
              loadOccupation = params.newLoadOccupation,
              newSlaveStatus = params.newSlaveStatus,
              selectedGroup = _.filter(groups, function(iterableGroup) {
                return (iterableGroup.code === groupId);
              })[0],
              masterPackageToAssign = _.filter(selectedGroup.packages, function(iterablePackage) {
                return iterablePackage.packageClassId === packageClassId;
              })[0];

            if (!masterPackageToAssign)
              masterPackageToAssign = selectedGroup.packages[0];

            if (this.isPossibleToChange(params.number, masterPackageToAssign.specialVars.slot, loadOccupation, newSlaveStatus))
              collectionEventAggregator.trigger("element:changeApproved", {
                packageClassId: packageClassId,
                newSlaveStatus: newSlaveStatus,
                choosenGroup: groupId
              });
            else
              collectionEventAggregator.trigger("element:changeNotApproved", {
                packageClassId: packageClassId,
                newSlaveStatus: newSlaveStatus,
                choosenGroup: groupId
              });

          }, this);

          collectionEventAggregator.bind("updateGlobalLengths", this.updateGlobalLengths, this);

          window.BticinoS4B.eventAggregator.bind("modelDeliver:request", this.deliverModel, this);
          window.BticinoS4B.eventAggregator.bind("systems:changed", this.systemsChangedEventHandler, this);
          window.BticinoS4B.eventAggregator.bind("currentDeliver:requested", this.deliverCurrent, this);

          window.BticinoS4B.eventAggregator.unbind("engines:addedFromKit", this.productAddedFromKitEventHandler);
          window.BticinoS4B.eventAggregator.bind("engines:addedFromKit", this.productAddedFromKitEventHandler, this);

          window.BticinoS4B.eventAggregator.unbind("engines:addAdditionalActuatorsToKit", this.addAdditionalActuatorsToKitEventHandler);
          window.BticinoS4B.eventAggregator.bind("engines:addAdditionalActuatorsToKit", this.addAdditionalActuatorsToKitEventHandler, this);

          BticinoS4B.Instances.Models.ApplicationModel.bind("change:lightPointsLength", this.sortItems, this);
          collectionEventAggregator.bind("updateViews", function() {
            this.trigger("updateViews");
          }, this);
        },

        isRemovable: function() {
          var isRemovable = true,
            collection = this.get("collection");

          for (var i = collection.models.length - 1; i >= 0; i--) {
            isRemovable = collection.models[i].get("partOfKit") ? false : true;
          }

          return isRemovable;
        },

        addAdditionalActuatorsToKitEventHandler: function(kitQuantity, optQuantity) {
          var that = this;
          var collection = this.get("collection") ? this.get("collection").models : undefined,
              collectionLength = collection ? collection.length : 0,
              tmpItemsToDel = [],
              i;

          //delete from the collection items not belonging to the kit 
          for (i = 0; i < collectionLength; i++) {
            if ( (!collection[i].get('partOfKit')) || (collection[i].get('partOfKit') === false) || (kitQuantity===0) ) {
              tmpItemsToDel.push(collection[i]);
            } else {
              collection[i].set('value', kitQuantity);
            }
          }

          for (i=0; i < tmpItemsToDel.length; i++){
            that.removeItem(tmpItemsToDel[i], true);
          }

          collectionLength = collection ? collection.length : 0;

          if ((collectionLength === 0) && (kitQuantity > 0)){
            // adding kit item
            that.addItem({
                  packageClassId: '1040',
                  value: kitQuantity,
                  partOfKit: true
            });
          }

          if (optQuantity>0){
            // adding new items if needs
            that.addItem({
                  packageClassId: '1040',
                  value: optQuantity,
                  partOfKit: false
            });
          }

          that.trigger("render:requested");
        },

        productAddedFromKitEventHandler: function(addedActuator) {
          var that = this,
            addKitItems = function() {
              that.addItem({
                packageClassId: addedActuator.packageClassId,
                value: addedActuator.quantity,
                partOfKit: true,
                kitsEventAggregator: addedActuator.kitsEventAggregator
              });

              that.trigger("render:requested");
              that.unbind("change:fetchingPackages", addKitItems);
            };

          if (this.get("fetchingPackages"))
            this.bind("change:fetchingPackages", addKitItems, this);
          else
            addKitItems();
        },

        deliverModel: function() {
          switch (BticinoS4B.vars.system.id) {
            case '#2':
              BticinoS4B.solution.thermoregulation.engines = this;
              break;
            case '#4':
              BticinoS4B.solution.intrusionDetection.engines = this;
              break;
            case '#5+6':
              BticinoS4B.solution.audioVideo.engines = this;
              break;
            case '#13+20':
              BticinoS4B.solution.automation.engines = this;
              break;
            case '#13':
              BticinoS4B.solution.automationSimple.engines = this;
              break;
            case '#21':
              BticinoS4B.solution.energyManagement.engines = this;
              break;
          };
          BticinoS4B.Instances.Models.ApplicationModel.set("engines", this);

          var dataProvider = BticinoS4B.Instances.Models.ApplicationModel.get("wizardModel").get("dataProvider"),
            collection = this.get("collection"),
            collectionLength = collection.models ? collection.models.length : 0,
            objectToReturn,
            toReturn = [],
            i = 0,
            j = 0;

          for (i = 0; i < collectionLength; i++) {
            if (!collection.models[i].get("isSlave"))
              objectToReturn = collection.models[i].get("masterPackage");
            else
              objectToReturn = collection.models[i].get("slavePackage");

            toReturn.push({
              productCode: objectToReturn.productCode,
              productLabel: objectToReturn.productLabel,
              packageClassLabel: objectToReturn.packageClassLabel,
              packageClassId: objectToReturn.packageClassId,
              kitValue: objectToReturn.kitValue,
              partOfKit: collection.models[i].get("partOfKit"),
              slotsnumber: objectToReturn.specialVars.slot,
              loadType: collection.models[i].get("typeOfEngine") === "rollingShutters" ? "t" : "p",
              requiredKeyCovers: objectToReturn.specialVars.requiredKeyCovers ? objectToReturn.specialVars.requiredKeyCovers : [],
              quantity: collection.models[i].get("value"),
              price: objectToReturn.price,
              Zn: "-6_2"
            });

            if (objectToReturn.secondaryProducts) {
              for (j = objectToReturn.secondaryProducts.length - 1; j >= 0; j--) {
                toReturn.push({
                  productCode: objectToReturn.secondaryProducts[j].productCode,
                  productLabel: objectToReturn.secondaryProducts[j].productLabel,
                  packageClassLabel: objectToReturn.secondaryProducts[j].packageClassLabel,
                  packageClassId: objectToReturn.secondaryProducts[j].packageClassId,
                  kitValue: objectToReturn.kitValue,
                  partOfKit: collection.models[i].get("partOfKit"),
                  quantity: collection.models[i].get("value"),
                  price: objectToReturn.secondaryProducts[j].price,
                  Zn: "-6_2"
                });
              }
            }

            if (objectToReturn.accessory) {
              toReturn.push({
                productCode: objectToReturn.accessory.productCode,
                productLabel: objectToReturn.accessory.productLabel,
                packageClassLabel: objectToReturn.accessory.packageClassLabel,
                packageClassId: objectToReturn.accessory.packageClassId,
                kitValue: objectToReturn.accessory.kitValue,
                partOfKit: collection.models[i].get("partOfKit"),
                quantity: collection.models[i].get("value"),
                price: objectToReturn.accessory.price,
                Zn: "-6_2"
              });
            }
          }

          return toReturn;
        },

        resetCollection: function() {
          if (this.get("collection") && this.get("collection").reset) {
            this.get("collection").reset();
            this.updateGlobalLengths();
          }
        },

        systemsChangedEventHandler: function() {
          var systems = BticinoS4B.Instances.Models.ApplicationModel.get("choosenSystems"),
            systemsLength = systems.length,
            i = 0;

          if (systemsLength > 0)
            for (i = 0; i < systemsLength; i++) {
              if (systems[i] === "lightsAndRollingShutters") {
                break;
              } else {
                if (i === (systemsLength - 1)) {
                  this.resetCollection();
                }
              }
            } else
              this.resetCollection();

          this.trigger("render:requested");
          this.trigger("updateViews");
        },

        getOptimizedActuators: function() {
          var actuators = this.get("collection").models ? this.get("collection").models : [],
            groupedActuators = _.groupBy(actuators, function(groupableActuators) {
              return groupableActuators.get("masterPackage").packageClassId;
            }),
            actuatorsCapacity = [],
            optimizedActuators = [],
            i = 0,
            j = 0;

          _.each(groupedActuators, function(val, key) {
            //if (val[0].get("masterPackage").specialVars.isMaster)
            //{
            var actuatorSlot = Number(val[0].get("masterPackage").specialVars.slot),
              loadOccupation = (val.length > 0) ? (val[0].get("typeOfEngine") === "rollingShutters" ? 2 : 4) : -1,
              loadsPerRow = 9,
              loadsPerActuator = actuatorSlot / loadOccupation,
              numberOfActuators = _.reduce(val, function(memo, actuator) {
                return memo + actuator.get("value");
              }, 0),
              actuatorsPerRow = Math.ceil(loadsPerRow / loadsPerActuator),
              neededActuators = Math.ceil(numberOfActuators * actuatorsPerRow / loadsPerRow);

            if (loadOccupation !== -1)
              for (i = 0; i < neededActuators; i++) {
                optimizedActuators.push(val[0]);
              }
              //}
          });

          return optimizedActuators;
        },

        calculateTotalAddress: function() {
          var collection = this.get("collection"),
            collectionLength = _.reduce(collection.models, function(memo, element) {

              if (!element.get("isSlave")) {
                var divider = element.get("typeOfEngine") === "rollingShutters" ? 2 : 4,
                  packageToAnalize = element.get("isSlave") ? element.get("slavePackage") : element.get("masterPackage");

                return memo + (element.get("value") * (packageToAnalize.specialVars.slot / divider));
              } else {
                return memo + 0;
              }
            }, 0);

          return collectionLength;
        },

        calculateTotalAddressOfMultipleSlotActuators: function() {
          var collection = this.get("collection"),
            collectionLength = _.reduce(collection.models, function(memo, element) {

              var divider = element.get("typeOfEngine") === "rollingShutters" ? 2 : 4,
                packageToAnalize = element.get("isSlave") ? element.get("slavePackage") : element.get("masterPackage");
              if (!element.get("isSlave") && packageToAnalize.specialVars.slot / divider > 1) {
                return memo + (element.get("value") * (packageToAnalize.specialVars.slot / divider));
              } else {
                return memo + 0;
              }

            }, 0);

          return collectionLength;
        },

        addPackageDetails: function() {
          this.packageClassIdChangedEventHandler();
          var isSlave = this.get("isSlave"),
            packageToSet;

          if (_isSlave)
            isSlave = _isSlave;

          var currentGroupId = this.get("choosenGroup"),
            groups = this.getGroups(isSlave),
            selectedGroup = _.filter(groups, function(iterableGroup) {
              return (iterableGroup.code === currentGroupId);
            })[0];

          if (!packageClassId) {
            if (isSlave)
              packageToSet = _.filter(selectedGroup.packages, function(iterablePackage) {
                return (!iterablePackage.specialVars.isMaster);
              })[0];
            else
              packageToSet = _.filter(selectedGroup.packages, function(iterablePackage) {
                return (iterablePackage.specialVars.isMaster);
              })[0];
          } else
            packageToSet = _.filter(selectedGroup.packages, function(iterablePackage) {
              return (iterablePackage.packageClassId === packageClassId);
            })[0];

          if (!packageToSet)
            packageToSet = selectedGroup.packages[0];

          this.fetchProduct(packageToSet, isSlave);

          if (isSlave)
            this.set("slavePackage", packageToSet);
          else
            this.set("masterPackage", packageToSet);
        },

        divideFetchedPackagesInGroups: function() {
          var fetchedPackages = this.get("fetchedPackages"),
            fetchedPackagesLength = fetchedPackages.length;

          var groups = _.groupBy(fetchedPackages, function(iterablePackage) {
            return iterablePackage.specialVars.groupId;
          }),
            choosenGroup = this.get("choosenGroup");
          groups = [{
            code: "1",
            name: "IDS_WAM1_821",
            packages: groups["1"]
          }, {
            code: "2",
            name: "IDS_WAM1_822",
            packages: groups["2"]
          }, {
            code: "3",
            name: "IDS_WAM1_823",
            packages: groups["3"]
          }, {
            code: "4",
            name: "IDS_WAM1_824",
            packages: groups["4"]
          }, {
            code: "5",
            name: "IDS_WAM1_825",
            packages: groups["5"]
          }];

          this.set("groups", groups);
        },

        fetchPackages: function() {
          this.trigger("packages:fetching");
          this.set("fetchingPackages", true);

          if (!this.get("packagesFetched")) {
            var that = this,
              groups = this.get("groups"),
            //Defining race conditions variables
              dataFetchCompleted = false,
              i = 0;

            //Race condition check
            var checkRaceCondition = function() {
              if (dataFetchCompleted) {
                that.divideFetchedPackagesInGroups();
                that.set("packagesFetched", true);
                that.trigger("packages:fetched");
                that.set("fetchingPackages", false);
              }
            };

            //Defining success callbacks
            var dataFetchSuccessCallback = function(data) {
              var fetchedPackages = data.packages,
                fetchedPackagesLength = fetchedPackages.length;

              for (i = 0; i < fetchedPackagesLength; i++) {
                if (fetchedPackages[i].specialVars && fetchedPackages[i].specialVars !== "" && typeof(fetchedPackages[i].specialVars) !== "object")
                  fetchedPackages[i].specialVars = JSON.parse(fetchedPackages[i].specialVars);
              }

              that.attributes.fetchedPackages = fetchedPackages;
              dataFetchCompleted = true;
              checkRaceCondition();
            };

            BticinoS4B.Instances.Models.ApplicationModel.getPackagesByIdWizardChoice("818", dataFetchSuccessCallback, undefined, true);
          }
        },

        updateGlobalLengths: function() {
          var collection = this.get("collection"),
            collectionLength = _.reduce(collection.models, function(memo, element) {
              if (!element.get("isSlave")) {
                var occupation = element.get("typeOfEngine") === "rollingShutters" ? 2 : 4,
                  loadsPerActuators = element.get("isSlave") ? element.get("slavePackage").specialVars.slot : element.get("masterPackage").specialVars.slot;

                loadsPerActuators = loadsPerActuators / occupation;

                return memo + (element.get("value") * loadsPerActuators);
              } else {
                return memo + 0;
              }
            }, 0);


          BticinoS4B.Instances.Models.ApplicationModel.set("enginesLength", collectionLength);
          BticinoS4B.Instances.Models.ApplicationModel.set("enginesAddressesLength", collectionLength);
          BticinoS4B.Instances.Models.ApplicationModel.set("enginesMultipleActuatorsLength", this.calculateTotalAddressOfMultipleSlotActuators());
        },

        isPossibleToAdd: function(actuatorSlots, loadOccupation, _quantity) {
          var collection = this.get("collection"),
            collectionLength = _.reduce(collection.models, function(memo, element) {
              return memo + element.get("value");
            }, 0),
            quantity = _quantity ? _quantity : 1,
            lightPointsLength = BticinoS4B.Instances.Models.ApplicationModel.get("lightPointsLength") ? BticinoS4B.Instances.Models.ApplicationModel.get("lightPointsLength") : 0,
            lightPointsMultipleActuatorsLength = BticinoS4B.Instances.Models.ApplicationModel.get("lightPointsMultipleActuatorsLength") ? BticinoS4B.Instances.Models.ApplicationModel.get("lightPointsMultipleActuatorsLength") : 0,
            quantityToAdd = actuatorSlots / loadOccupation * quantity,
            maxItem = this.get("maxItem");

          if (actuatorSlots / loadOccupation > 1) {
            if (this.calculateTotalAddressOfMultipleSlotActuators() + lightPointsMultipleActuatorsLength + quantityToAdd <= 72) {
              if ((this.calculateTotalAddress() + lightPointsLength + quantityToAdd) <= maxItem)
                return true;
              else
                return false;
            } else
              return false;
          } else {
            if ((this.calculateTotalAddress() + lightPointsLength + quantityToAdd) <= maxItem)
              return true;
            else
              return false;
          }
        },

        isPossibleToChange: function(number, newElementSlots, newLoadOccupation, _newSlaveStatus) {
          var collection = this.get("collection"),
            lightPointsLength = BticinoS4B.Instances.Models.ApplicationModel.get("lightPointsLength") ? BticinoS4B.Instances.Models.ApplicationModel.get("lightPointsLength") : 0,
            elementToVerify = _.filter(collection.models, function(iterable) {
              return iterable.get("number") === number;
            })[0],
            packageToGet = elementToVerify ? (elementToVerify.get("isSlave") ? "slavePackage" : "masterPackage") : "",
            oldSlotOccupaton = elementToVerify ? (elementToVerify.get("typeOfEngine") === "rollingShutters" ? 2 : 4) : 2,
            newSlaveStatus = this.get("isSlave");

          var maxItem = this.get("maxItem"),
            oldElementLength = elementToVerify ? elementToVerify.get("value") * elementToVerify.get(packageToGet).specialVars.slot / oldSlotOccupaton : 1,
            newElementHypoteticalLength = elementToVerify ? elementToVerify.get("value") * newElementSlots / newLoadOccupation : 1,
            lightPointsMultipleActuatorsLength = BticinoS4B.Instances.Models.ApplicationModel.get("lightPointsMultipleActuatorsLength") ? BticinoS4B.Instances.Models.ApplicationModel.get("lightPointsMultipleActuatorsLength") : 0;

          if (_newSlaveStatus !== undefined)
            newSlaveStatus = _newSlaveStatus;
          else
            newSlaveStatus = elementToVerify ? elementToVerify.get("isSlave") : false;

          if (elementToVerify && elementToVerify.get("isSlave"))
            oldElementLength = 0;

          if (newSlaveStatus === false) {
            if (newElementSlots / newLoadOccupation > 1) {
              if (this.calculateTotalAddressOfMultipleSlotActuators() + lightPointsMultipleActuatorsLength - oldElementLength + newElementHypoteticalLength <= 72) {
                if ((this.calculateTotalAddress() + lightPointsLength - oldElementLength + newElementHypoteticalLength) <= maxItem)
                  return true;
                else
                  return false;
              } else
                return false;
            } else {
              if ((this.calculateTotalAddress() + lightPointsLength - oldElementLength + newElementHypoteticalLength) <= maxItem)
                return true;
              else
                return false;
            }
          } else
            return true;
        },

        addItem: function(itemModel) {
          var collection = this.get("collection"),
            collectionLength = collection.length,
            collectionItemModel = genericCollectionItem.Model,
            itemsToAdd = [],
            defaultItem;

          if (itemModel)
            defaultItem = new collectionItemModel(_.extend(itemModel, {
              groups: this.get("groups"),
              number: this.getNewNumber(),
              collectionEventAggregator: this.get("collectionEventAggregator")
            }));
          else
            defaultItem = new collectionItemModel({
              groups: this.get("groups"),
              number: this.getNewNumber(),
              collectionEventAggregator: this.get("collectionEventAggregator")
            });

          var slots = !defaultItem.get("isSlave") ? defaultItem.get("masterPackage").specialVars.slot : 0,
            loadOccupation = defaultItem.get("typeOfEngine") === "rollingShutters" ? 2 : 4;

          if (this.isPossibleToAdd(slots, loadOccupation)) {
            itemsToAdd.push(defaultItem);
            if (genericCollectionSection.Model.prototype.addItem.apply(this, itemsToAdd)) {
              this.updateGlobalLengths();
              this.get("collectionEventAggregator").trigger("updateViews");
              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
              this.sortItems();
              return defaultItem;
            }
          } else {
            alert($.i18n._('IDS_W1_9128'));
            return false;
          }
        },

        duplicateItem: function(modelToDuplicate) {
          var collectionItemModel = genericCollectionItem.Model,
            itemNumber = this.getNewNumber(),
            loadOccupation = modelToDuplicate.get("typeOfEngine") === "rollingShutters" ? 2 : 4,
            collection = this.get("collection"),
            collectionLength = collection.length,
            packageToDuplicate = modelToDuplicate.get("isSlave") ? modelToDuplicate.get("slavePackage") : modelToDuplicate.get("masterPackage");

          if (this.isPossibleToAdd(packageToDuplicate.specialVars.slot, loadOccupation, modelToDuplicate.get("value"))) {
            var attributesToDuplicate = {
              choosenGroup: modelToDuplicate.get("choosenGroup"),
              description: modelToDuplicate.get("description"),
              filterId: modelToDuplicate.get("filterId"),
              generatedId: modelToDuplicate.get("generatedId"),
              groups: modelToDuplicate.get("groups"),
              isSlave: modelToDuplicate.get("isSlave"),
              masterPackage: modelToDuplicate.get("masterPackage"),
              number: modelToDuplicate.get("number"),
              packageClassId: modelToDuplicate.get("packageClassId"),
              partOfKit: false,
              slavePackage: modelToDuplicate.get("slavePackage"),
              slaveValue: modelToDuplicate.get("slaveValue"),
              typeOfEngine: modelToDuplicate.get("typeOfEngine"),
              value: modelToDuplicate.get("value")
            };
            attributesToDuplicate.masterPackage = _.extend({}, attributesToDuplicate.masterPackage);
            attributesToDuplicate.slavePackage = _.extend({}, attributesToDuplicate.slavePackage);

            if (attributesToDuplicate) {
              modelToDuplicate.set("number", itemNumber);
              this.addItem(attributesToDuplicate);
              this.trigger("updateViews", this.get("collection").length);
              this.updateGlobalLengths();
              this.get("collectionEventAggregator").trigger("updateViews");
              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");
              this.sortItems();
              return modelToDuplicate;
            } else
              return false;
          } else {
            alert($.i18n._('IDS_W1_9128'));
            return false;
          }
        },

        removeItem: function(modelToRemove, _silent) {
          var silent = false;

          if (_silent)
            silent = _silent;

          if (!modelToRemove.get("partOfKit") || silent) {
            if (this.deleteItem(modelToRemove, silent)) {
              this.trigger("updateViews", this.get("collection").length);

              this.sortItems();
              this.updateGlobalLengths();
              this.get("collectionEventAggregator").trigger("updateViews");
              //Trigger event for zone validation
              this.trigger("item:removed");
              this.trigger("render:requested");

              window.BticinoS4B.eventAggregator.trigger("currentDeliver:requested");

              return modelToRemove;
            }
          } else{
            alert($.i18n._('IDS_W1_9191'));
            return false;
          }
        },

        sortItems: function() {
          var collection = this.get("collection"),
            collectionLength = collection.length;
          var i = 0;

          if (collection.models)
            for (i = 0; i < collectionLength; i++) {
              collection.models[i].set("number", (i + 1));
              if (i === (collectionLength - 1))
                collection.models[i].set("selected", true);
              else
                collection.models[i].set("selected", false);
            }
        },

        deliverCurrent: function() {
          var collection = this.get("collection").models,
            collectionLength = collection ? collection.length : 0;
          var consumptionIndicatorModel = BticinoS4B.Instances.Models.ApplicationModel.get("consumptionIndicatorModel");
          var extraConsumption = 30; //30 mA of extra consumption
          var mustDeliverExtraConsumption = false;
          var i = 0;

          //Delivering regular consumptions
          for (i = 0; i < collectionLength; i++)
            collection[i].deliverCurrent();
        },

        loadProject: function(project) {
          var that = this,
            oldCollection,
            i = 0,
            load = function() {
              if (that.get("collection")) {
                oldCollection = that.get("collection");
                if (oldCollection.models) oldCollection = oldCollection.models;
              }

              that.set("collection", new collectionModel());
              collection = that.get("collection");

              if (oldCollection) {
                for (i = 0; i < oldCollection.length; i++) {
                  if (!oldCollection[i].attributes)
                    that.addItem(_.extend({
                      collectionEventAggregator: that.get("collectionEventAggregator")
                    }, oldCollection[i]));
                  else
                    collection.add(new collectionItemModel($.extend({}, oldCollection[i].attributes)));
                }
                that.set("collection", collection);
                that.get("collectionEventAggregator").trigger("updateGlobalLengths");
                that.trigger("updateViews");
                window.BticinoS4B.eventAggregator.trigger("modelDeliver:request");
              }
            };

          if (project.automation && project.automation.enginesModel)
            this.set("collection", project.automation.enginesModel.collection);

          if (!this.get("fetchedPackages"))
            this.bind("packages:fetched", load);
          else
            load();
        }
      }),
      genericCollectionItem: genericCollectionItem
    });

    // Required, return the module for AMD compliance
    return engines;

  });